var exports = {
  "kL": "x61f99309--126f9a--container",
  "Tq": "x61f99309--126f9a--bubble",
  "hD": "x61f99309--126f9a--quote",
  "Zp": "x61f99309--126f9a--layout",
  "Qs": "x61f99309--126f9a--content",
  "mI": "x61f99309--126f9a--meta",
  "AX": "x61f99309--126f9a--text-message",
  "Hk": "x61f99309--126f9a--action-buttons",
};

module.exports = exports;
